import React, { useCallback, useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiMaskPaintPreview from "../../shared/Popup/AiMaskPaintPreview";
import AiMaskSelectToolControls, {
  isMaskSelectGenerateReady,
} from "../../shared/Popup/AiMaskSelectToolControls";
import { useAiMaskPaint } from "../../shared/Popup/useAiMaskPaint";

/**
 * AI Tools → AI Remove Watermark prep (Smart / Brush / Box / Eraser).
 */
const RemoveWatermarkToolPrep = (props) => {
  const [prompt, setPrompt] = useState("");
  const paint = useAiMaskPaint();
  const toolId = paint.paintTool;

  const isGenerateReady = useCallback(
    () => isMaskSelectGenerateReady(toolId, paint.hasMask),
    [toolId, paint.hasMask]
  );

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_remove_watermark"
      title="AI Remove Watermark"
      aka="Watermark Remover"
      bio="Remove watermarks and logos, then reconstruct the image underneath."
      emptyPreviewLabel="Upload an image to preview watermark removal"
      loadingLabel="Removing watermark…"
      emptyFooterHint="Upload an image, pick a tool, then generate."
      isGenerateReady={isGenerateReady}
      renderPreview={({
        imageUrl,
        loading,
        loadingLabel,
        emptyLabel,
        hasResult,
      }) => (
        <AiMaskPaintPreview
          ref={paint.maskRef}
          imageUrl={imageUrl}
          loading={loading}
          loadingLabel={loadingLabel}
          emptyLabel={emptyLabel}
          tool={toolId}
          brushSize={paint.brushSize}
          paintEnabled={
            !hasResult &&
            Boolean(imageUrl) &&
            !loading &&
            toolId !== "smart"
          }
          clearVersion={paint.clearVersion}
          onMaskChange={paint.handleMaskChange}
        />
      )}
      renderControls={({ busy, leftPanelRef, sourceImageUrl }) => (
        <>
          <AiMaskSelectToolControls
            paint={paint}
            busy={busy}
            sourceImageUrl={sourceImageUrl}
            leftPanelRef={leftPanelRef}
            subject="watermark"
          />

          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-rw-prompt">
              Describe the watermark
              <span className="aftp-optional"> (optional)</span>
            </label>
            <textarea
              id="aftp-rw-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. the semi-transparent logo in the center"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default RemoveWatermarkToolPrep;
